/**
 * In-memory cache for GetKitchensByManagingBranch responses.
 * Key: branch + page + limit + server-side filter params.
 */

const cache = new Map();

/**
 * @param {object} [filters]
 * @param {string} [filters.kitchen_name_search]
 * @param {'all'|'Active'|'Inactive'} [filters.statusFilter]
 * @param {string} [filters.storeVisibilityFilter] 'all' or canonical visibility value
 */
export function kitchenListCacheKey(branch, page, limit, filters = {}) {
  const kitchen = String(filters.kitchen_name_search ?? '').trim();
  const status = filters.statusFilter ?? 'all';
  const vis = filters.storeVisibilityFilter ?? 'all';
  return `${branch}|${page}|${limit}|${kitchen}|${status}|${vis}`;
}

/**
 * @returns {{ rows: object[], totalKitchens: number, refreshedAt: number } | null}
 */
export function getKitchenListPageCache(branch, page, limit, filters) {
  return cache.get(kitchenListCacheKey(branch, page, limit, filters)) ?? null;
}

export function setKitchenListPageCache(branch, page, limit, entry, filters) {
  const key = kitchenListCacheKey(branch, page, limit, filters);
  cache.set(key, {
    rows: entry.rows,
    totalKitchens: entry.totalKitchens,
    refreshedAt: entry.refreshedAt ?? Date.now(),
  });
}

export function invalidateKitchenListPageCache(branch, page, limit, filters) {
  cache.delete(kitchenListCacheKey(branch, page, limit, filters));
}
